module.exports = __webpack_public_path__ + "static/colliery-e603971e9ad4249a154cf89024accbea.png";